export const CLIENT_ROUTE = '/playlist';
export const API_ROUTE = '/api/playlist';
export const CLIENT_TITLE = 'Playlist';